var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.buttonClasses,style:(_vm.styleObject),attrs:{"slot":_vm.slotName},slot:_vm.slotName})}
var staticRenderFns = []

export { render, staticRenderFns }